import axios from "axios";

export async function getIdFromToken() {
    try {
        const decodedToken = await axios.get(`${process.env.REACT_APP_API_URL}/user/decode`, {
            withCredentials: true,
            headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' },
        })
        return decodedToken.data.decoded.payload.user;
    }
    catch (err) {
        throw new Error("User Not Found", err)
    }
}
